import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShieldHeart } from "@fortawesome/pro-solid-svg-icons";
import { Button } from "./ui/Button";

interface PlatinumRecommendationBannerProps {
    onUpgrade: () => void;
}

export function PlatinumRecommendationBanner({ onUpgrade }: PlatinumRecommendationBannerProps) {
    return (
        <div data-testid="platinum-rec-banner" className="mt-16 flex rounded-lg bg-background-warning p-2 sm:mt-11 sm:p-3 md:mt-28 lg:mt-16">
            <div className="text-sm font-medium text-content-primary">
                <FontAwesomeIcon icon={faShieldHeart} className="mr-1 inline-block size-4 align-text-top" />
                <span className="font-bold">Platinum coverage</span> covers even more essentials like spay, neuter, and flea and heartworm prevention.{" "}
                <Button data-testid="btn-upgrade-platinum" size="auto" onClick={onUpgrade} variant="link" className="text-sm text-content-brand-b underline">
                    Upgrade
                </Button>
            </div>
        </div>
    );
}
